import { createScopedDescriptor } from 'quartz/globalState/api';
// Create a silo property to store the result of the auth tool's setup
export const APP_AUTH_RESULT = createScopedDescriptor('appAuthResult', 'BROWSING_CONTEXT');